export const GreenOkCircle = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.9053 2C7.38527 2 2.90527 6.48 2.90527 12C2.90527 17.52 7.38527 22 12.9053 22C18.4253 22 22.9053 17.52 22.9053 12C22.9053 6.48 18.4253 2 12.9053 2ZM10.9053 17.5L5.90527 12.5L7.31527 11.09L10.9053 14.67L18.0753 7.5L19.4903 8.92L10.9053 17.5Z"
      fill="#17850F"
    />
  </svg>
);
